<template>
  <div>
    <el-button v-if="formType=='edit'" type="primary" size="mini" style="margin-bottom:20px" @click="addjihua">添加一条</el-button>
    <el-table v-loading="table_loading" :data="tableData" style="width:100%" class="grayTableTile_02">

      <el-table-column label="测试阶段名称" :show-overflow-tooltip="true" :min-width="formType=='edit'?'140px':'140px'" fixed="left">
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji">
            <el-input v-model="scope.row.stageName" maxlength="6" size="mini" />
          </span>
          <span v-else>
            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top"> -->
            <span>{{ scope.row.stageName }}</span>
            <!-- </el-tooltip> -->
          </span>
        </template>
      </el-table-column>

      <el-table-column label="日志环境" min-width="120px">
        <template slot="header" slot-scope="scope">
          <span>日志环境</span>
          <el-popover popper-class="table-popper" placement="top-start" width="250" trigger="hover" content="广告相关计算只涉及到正式环境">
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: baseline;margin-left: 5px;" />
          </el-popover>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 2 || scope.row.state == -1)">
            <el-select v-model="scope.row.platform" size="mini" @change="setStageOption($event, scope.row)">
              <el-option value="SERVER_TEST" label="测试" />
              <el-option value="SERVER" label="正式" />
            </el-select>
          </span>
          <span v-else>{{ scope.row.platform | platformFilters }}</span>
        </template>
      </el-table-column>

      <el-table-column label="测试版本" :min-width="formType=='edit'?'120px':'80px'">
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 2 || scope.row.state == -1)">
            <el-select v-model="scope.row.stage" size="mini" @change="setStageOption">
              <el-option v-for="item in defaultJieDuan" :key="item.value" :value="item.value" :label="item.label" :disabled="(scope.row.platform == 'SERVER_TEST' && item.value == 99) || (scope.row.platform == 'SERVER_TEST' && testStage.test.includes(item.value)) || (scope.row.platform == 'SERVER' && testStage.master.includes(item.value))" />
            </el-select>
          </span>
          <span v-else>
            <span v-if="scope.row.state == 0 && scope.row.stage == 99">
              下线
            </span>
            <span v-else>
              {{ scope.row.stage | stageFilters(defaultJieDuan) }}
            </span>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="客户端激活时间" :min-width="formType=='edit'?'200px':'150px'">
        <template slot="header" slot-scope="scope">
          <span>客户端激活时间</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="国内为北京时间，海外为当地时间"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>

        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 2 || scope.row.state == -1)">
            <el-date-picker v-model="scope.row.clientTime" :disabled="formType == 'look'" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="客户端激活时间" style="width:180px" size="mini" />
          </span>
          <span v-else>{{ scope.row.clientTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="服务端新增时间" :min-width="formType=='edit'?'200px':'150px'">
        <template slot="header" slot-scope="scope">
          <span>服务端新增时间</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="国内为北京时间，海外为当地时间"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>

        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 3 || scope.row.state == 2 || scope.row.state == -1)">
            <el-date-picker v-model="scope.row.serverTime" :disabled="formType == 'look'" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="服务端新增时间" style="width:180px" size="mini" />
          </span>
          <span v-else>{{ scope.row.serverTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="开服时间" :min-width="formType=='edit'?'200px':'150px'">
        <template slot="header" slot-scope="scope">
          <span>开服时间</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="国内为北京时间，海外为当地时间"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>

        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 1 || scope.row.state == 2 || scope.row.state == 3 || scope.row.state == -1)">
            <el-date-picker v-model="scope.row.startTime" :disabled="formType == 'look'" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="开服时间" style="width:180px" size="mini" />
          </span>
          <span v-else>{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="关服时间" :min-width="formType=='edit'?'200px':'150px'">
        <template slot="header" slot-scope="scope">
          <span>关服时间</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="国内为北京时间，海外为当地时间"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>

        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 1 || scope.row.state == 2 || scope.row.state == 3 || scope.row.state == -1)">
            <el-date-picker v-model="scope.row.endTime" :disabled="formType == 'look'" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="关服时间" style="width:180px" size="mini" />
          </span>
          <span v-else>{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否付费" :min-width="formType=='edit'?'120px':'80px'">
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji">
            <el-select v-model="scope.row.isCharge" size="mini">
              <el-option :value="1" label="付费" />
              <el-option :value="0" label="非付费" />
            </el-select>
          </span>
          <span v-else>{{ scope.row.isCharge | isChargeFilters }}</span>
        </template>
      </el-table-column>

      <el-table-column label="日志环境" :min-width="formType=='edit'?'120px':'100px'">
        <template slot="header" slot-scope="scope">
          <span>日志环境</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="广告相关计算只涉及到正式环境"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji && (scope.row.state == 2 || scope.row.state == -1)">
            <el-select v-model="scope.row.platform" size="mini">
              <el-option value="SERVER_TEST" label="测试" />
              <el-option value="SERVER" label="正式" />
            </el-select>
          </span>
          <span v-else>{{ scope.row.platform | platformFilters }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否生效" :min-width="formType=='edit'?'120px':'100px'">
        <template slot="header" slot-scope="scope">
          <span>是否生效</span>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="关服时间<当前时间，则为失效状态；关服时间>=当前时间，即为生效状态，失效状态数据不进行计算"
          >
            <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
          </el-popover>
        </template>

        <template slot-scope="scope">
          <span>{{ scope.row.state | stateFilters }}</span>
          <!-- <span v-if="scope.row.ifbianji">
            <el-select v-model="scope.row.state" size="mini">
              <el-option :value="1" label="生效"></el-option>
              <el-option :value="0" label="失效"></el-option>
            </el-select>
          </span>
          <span v-else>{{scope.row.state}}</span> -->
        </template>
      </el-table-column>
      <el-table-column label="是否保留平台数据" :min-width="formType=='edit'?'140px':'140px'">
        <template slot-scope="scope">
          <span>{{ scope.row.dataState | dataStateFilters }}</span>
          <!-- <span v-if="scope.row.ifbianji">
            <el-select v-model="scope.row.dataState" size="mini">
              <el-option :value="1" label="保留"></el-option>
              <el-option :value="2" label="删除"></el-option>
            </el-select>
            保留
          </span>
          <span v-else>{{scope.row.dataState}}</span> -->
        </template>
      </el-table-column>
      <el-table-column label="备注" :show-overflow-tooltip="true" :min-width="formType=='edit'?'140px':'140px'">
        <template slot-scope="scope">
          <span v-if="scope.row.ifbianji">
            <el-input v-model="scope.row.remark" type="textarea" :rows="1" size="mini" />
          </span>
          <span v-else>
            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top"> -->
            <span>{{ scope.row.remark }}</span>
            <!-- </el-tooltip> -->
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="formType == 'edit'" prop="name" label="操作" fixed="right" :min-width="formType=='edit'?'150px':'150px'">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.baocunshow" class="item" effect="dark" content="保存" placement="top">
            <i class="el-icon-check" style="color:#67C23A;cursor: pointer;font-size:20px;margin-right:10px" @click="baocun_fn(scope.row)" />
          </el-tooltip>
          <el-tooltip v-if="scope.row.bianjishow" class="item" effect="dark" content="编辑" placement="top">
            <i class="el-icon-edit" style="color:#409EFF;cursor: pointer;font-size:20px;margin-right:10px" @click="bianji_fn(scope.row)" />
          </el-tooltip>
          <el-tooltip v-if="scope.row.shanchushow && (scope.row.stage == 0 || scope.row.state == 2)" class="item" effect="dark" content="删除" placement="top">
            <i class="el-icon-delete" style="color:#E6A23C;cursor: pointer;font-size:20px;margin-right:10px" @click="delete_fn(scope.row,scope.$index)" />
          </el-tooltip>
          <el-tooltip v-if="scope.row.quxiaoshow" class="item" effect="dark" content="取消" placement="top">
            <i class="el-icon-circle-close" style="color:#F56C6C;cursor: pointer;font-size:20px;margin-right:10px" @click="delete_fn(scope.row,scope.$index)" />
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="删库" placement="top">
            <svg-icon icon-class="delete-database" v-if="scope.row.shankushow" class="icon" style="color:#F56C6C;cursor: pointer;font-size:20px;margin-right:10px" />
          </el-tooltip> -->
          <!-- :icon-class="scope.row.isHide==1?'xianshi':'yincang'" -->
          <el-tooltip v-if="scope.row.yincangshow" class="item" effect="dark" :content="scope.row.isHide==1?'点击可对外显示此条数据':'点击可对外隐藏此条数据'" placement="top">
            <svg-icon :icon-class="scope.row.isHide==1?'yincang':'xianshi'" class="icon" style="color:#909399;cursor: pointer;font-size:20px" @click="show_fn(scope.row)" />
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { product_time_queryList, product_time_create, product_time_update, product_time_deleteById, product_time_updateIsHide } from '@Sys~/api/sys'
// 弹窗默认的数据内容

export default {
  components: {},
  filters: {
    stageFilters(val, list) {
      var label = ''
      list.forEach(item => {
        if (item.value == val) {
          label = item.label
        }
      })
      return label
    },
    isChargeFilters(status) {
      const statusMap = {
        0: '非付费',
        1: '付费'
      }
      return statusMap[status]
    },
    platformFilters(status) {
      const statusMap = {
        SERVER_TEST: '测试',
        SERVER: '正式'
      }
      return statusMap[status]
    },
    stateFilters(status) {
      const statusMap = {
        0: '失效',
        1: '服务端生效',
        2: '未生效',
        3: '客户端生效',
        '-1': '-'
      }
      return statusMap[status]
    },
    dataStateFilters(status) {
      const statusMap = {
        1: '保留',
        2: '待删除',
        3: '删除中',
        4: '已删除'
      }
      return statusMap[status]
    }

  },
  data() {
    return {
      shadddivif: false,
      formType: 'add',
      appkey: '',
      gname: '',
      defaultJieDuan: [
        {
          value: 1,
          label: 'V1'
        },
        {
          value: 2,
          label: 'V2'
        },
        {
          value: 3,
          label: 'V3'
        },
        {
          value: 4,
          label: 'V4'
        },
        {
          value: 5,
          label: 'V5'
        },
        {
          value: 6,
          label: 'V6'
        },
        {
          value: 7,
          label: 'V7'
        },
        {
          value: 8,
          label: 'V8'
        },
        {
          value: 9,
          label: 'V9'
        },
        {
          value: 10,
          label: 'V10'
        },
        {
          value: 11,
          label: 'V11'
        },
        {
          value: 12,
          label: 'V12'
        },
        {
          value: 13,
          label: 'V13'
        },
        {
          value: 14,
          label: 'V14'
        },
        {
          value: 15,
          label: 'V15'
        },
        {
          value: 16,
          label: 'V16'
        },
        {
          value: 17,
          label: 'V17'
        },
        {
          value: 18,
          label: 'V18'
        },
        {
          value: 19,
          label: 'V19'
        },
        {
          value: 20,
          label: 'V20'
        },
        {
          value: 99,
          label: '正式上线'
        },
        {
          value: 0,
          label: '临测'
        }
      ],

      jieduanList: [],

      ceshi: {

        id: '',
        appkey: '', // 游戏标识
        platform: 'SERVER_TEST', // 应用环境 SERVER_TEST:测试，SERVER：正式
        stage: 1, // 阶段 1-9:1测-9测 0:临测 99正式上线
        isCharge: 0, // 是否开启付费 0:关闭 1开启
        clientTime: '', // 客户端激活时间
        serverTime: '', // 服务端新增时间
        startTime: '', // 开服时间
        endTime: '', // 关服时间
        isHide: 0, // 是否隐藏 0:否 1是
        remark: '', // 备注

        dataState: 1, // 删库状态
        state: -1, // 0:失效 1生效（游戏下仅有一个生效）

        ifbianji: true, // 是否编辑此行

        baocunshow: true, // 是否显示保存按钮
        bianjishow: false, // 是否显示编辑按钮
        shanchushow: false, // 是否显示删除按钮
        shankushow: false, // 是否显示删库按钮
        yincangshow: false, // 是否显示隐藏按钮
        quxiaoshow: true// 是否显示取消按钮

      },

      tableData: [],
      table_loading: false,

      // 时区
      timeZoneDesc: ''
    }
  },
  methods: {
    // 初始化列表
    init() {
      // 查询游戏详情
      if (this.formType == 'edit') {
        var isHide = ''
      } else {
        var isHide = 0
      }
      this.table_loading = true
      product_time_queryList({ appkey: this.appkey, isHide: isHide }).then(response => {
        if (response.code == 1) {
          response.data.forEach(item => {
            item.ifbianji = false// 是否编辑此行
            item.baocunshow = false // 是否显示保存按钮
            item.bianjishow = true // 是否显示编辑按钮
            item.shanchushow = true // 是否显示删除按钮
            item.shankushow = false // 是否显示删库按钮
            item.yincangshow = true // 是否显示隐藏按钮
            item.quxiaoshow = false // 是否显示取消按钮
          })
          this.tableData = response.data
          this.table_loading = false

          if (this.tableData.length < 1 && this.formType == 'edit') {
            var newdata = JSON.parse(JSON.stringify(this.ceshi))
            newdata.appkey = this.appkey
            this.tableData.push(newdata)
          }

          // 时区
          if (response.extra && response.extra.timeZoneDesc) {
            this.timeZoneDesc = response.extra.timeZoneDesc
            this.$emit('timeCallback', this.gname + this.timeZoneDesc)
          }
        }
      })
    },

    // 更新阶段list
    jieduan() {
      this.jieduanList = []
      if (this.tableData.length > 0) {
        var arr = []
        this.defaultJieDuan.forEach(item => {
          var dis = true
          this.tableData.forEach(datas => {
            if (item.value == datas.stage) {
              dis = false
            }
          })
          if (dis) {
            arr.push(item)
          }
        })
        this.jieduanList = JSON.parse(JSON.stringify(arr))
      } else {
        this.jieduanList = JSON.parse(JSON.stringify(this.defaultJieDuan))
      }
    },

    // 添加一行
    addjihua() {
      // this.jieduan()
      // this.jieduanList = JSON.parse(JSON.stringify(this.defaultJieDuan))
      var newdata = JSON.parse(JSON.stringify(this.ceshi))
      // newdata.stage = this.jieduanList[0].value
      newdata.appkey = this.appkey
      this.tableData.push(newdata)
    },

    // 可编辑入口
    createNodeInit(appkey, name) {
      this.appkey = appkey
      this.gname = name
      if (this.$route.name == 'game_manage') {
        this.formType = 'edit'
      } else {
        this.formType = 'look'
      }
      this.init()
    },

    // 只查看入口
    lookInit(appkey) {
      this.appkey = appkey
      this.formType = 'look'
      this.init()
    },

    ruleForm(row) {
      row.clientTime = row.clientTime == null ? '' : row.clientTime
      row.serverTime = row.serverTime == null ? '' : row.serverTime
      row.startTime = row.startTime == null ? '' : row.startTime
      row.endTime = row.endTime == null ? '' : row.endTime

      if (row.clientTime.length == 16) {
        row.clientTime += ':00'
      }
      if (row.serverTime.length == 16) {
        row.serverTime += ':00'
      }
      if (row.startTime.length == 16) {
        row.startTime += ':00'
      }
      if (row.endTime.length == 16) {
        row.endTime += ':00'
      }

      return true
    },

    // 保存测试时间
    baocun_fn(row) {
      if (this.ruleForm(row)) {
        console.log(row.stage == 99 && (row.endTime == '' || row.endTime == null))
        if (row.endTime == '' || row.endTime == null) {
          this.$confirm('未设置关服时间，将默认填写最大时间2099-01-01 23:59:00', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.baocun(row)
          }).catch(() => {
          })
        } else {
          this.baocun(row)
        }
      }
    },

    baocun(row) {
      row.updateUser = this.$store.getters.userInfo.realname
      if (row.id == '') {
        product_time_create(row).then(response => {
          if (response.code == 1) {
            this.$message.success('保存成功')
            // row.id = response.data.id
            // row.isHide = response.data.isHide
            // row.endTime = response.data.endTime
            // row.isHide = response.data.isHide
            // row.state = response.data.state

            this.init()

            row.ifbianji = false// 是否编辑此行
            row.baocunshow = false // 是否显示保存按钮
            row.bianjishow = true // 是否显示编辑按钮
            row.shanchushow = true // 是否显示删除按钮
            row.shankushow = true // 是否显示删库按钮
            row.yincangshow = true // 是否显示隐藏按钮
            row.quxiaoshow = false // 是否显示取消按钮
          }
        })
      } else {
        product_time_update(row).then(response => {
          if (response.code == 1) {
            this.$message.success('保存成功')
            // row.id = response.data.id
            // row.isHide = response.data.isHide
            // row.endTime = response.data.endTime
            // row.isHide = response.data.isHide
            // row.state = response.data.state

            this.init()

            row.ifbianji = false// 是否编辑此行
            row.baocunshow = false // 是否显示保存按钮
            row.bianjishow = true // 是否显示编辑按钮
            row.shanchushow = true // 是否显示删除按钮
            row.shankushow = true // 是否显示删库按钮
            row.yincangshow = true // 是否显示隐藏按钮
            row.quxiaoshow = false // 是否显示取消按钮
          }
        })
      }
    },

    // 点击编辑
    bianji_fn(row) {
      console.log(row)
      row.ifbianji = true// 是否编辑此行
      row.baocunshow = true // 是否显示保存按钮
      row.bianjishow = false // 是否显示编辑按钮
      row.shanchushow = true // 是否显示删除按钮
      row.shankushow = false // 是否显示删库按钮
      row.yincangshow = false // 是否显示隐藏按钮
      row.quxiaoshow = false // 是否显示取消按钮
    },
    // 删除测试时间
    delete_fn(row, i) {
      this.$confirm('此操作将删除本条数据！是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.id != '' && row.id != null) {
          product_time_deleteById({ id: row.id }).then(response => {
            if (response.code == 1) {
              this.$message.success(response.msg)
              this.tableData.splice(i, 1)
            }
          })
        } else {
          this.tableData.splice(i, 1)
        }
      }).catch(() => {
      })
    },

    // 隐藏测试时间
    show_fn(row) {
      console.log(row)
      var isHide
      if (row.isHide == 1) {
        var isHide = 0
        var str = '此操作将对外显示此条数据, 是否继续?'
      } else {
        var isHide = 1
        var str = '此操作将对外隐藏此条数据, 是否继续?'
      }

      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        product_time_updateIsHide({ id: row.id, isHide: isHide }).then(response => {
          if (response.code == 1) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.tableData.forEach(element => {
              if (element.id == row.id) {
                element.isHide = isHide
              }
            })
          }
        })
      }).catch(() => {

      })
    }

  }

}
</script>

<style lang="scss" scoped>
.dialog ::v-deep .el-dialog__body {
  // height: 700px;
  padding: 20px 20px 50px;
  overflow: hidden;

  .scrollbar-wrapper {
    height: 620px;
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }
}
.flex-form {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;

  .el-form-item {
    min-width: 32%;
  }

  .all {
    min-width: 98%;
  }
}

// table 定位有条线
::v-deep .el-table__fixed-right:before, ::v-deep .el-table__fixed:before{
  background-color: transparent ;
}
</style>
